import Axios from "axios";
var ShopActivityService = (function () {
    function ShopActivityService() {
    }
    ShopActivityService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/shopping_activity/list", { params: params });
    };
    ShopActivityService.prototype.save = function (params) {
        return Axios.post("supplierclientapi/shopping_activity/create", params);
    };
    ShopActivityService.prototype.update = function (params) {
        return Axios.post("supplierclientapi/shopping_activity/update", params);
    };
    ShopActivityService.prototype.publish = function (params) {
        return Axios.post("supplierclientapi/shopping_activity/release", params);
    };
    ShopActivityService.prototype.stopActivity = function (params) {
        return Axios.post("supplierclientapi/shopping_activity/stop", params);
    };
    ShopActivityService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/shopping_activity/detail", { params: params });
    };
    ShopActivityService.prototype.getActCusList = function (params) {
        return Axios.get("supplierclientapi/shopping_activity/join_log", { params: params });
    };
    ShopActivityService.prototype.getActOrderLogList = function (params) {
        return Axios.get("supplierclientapi/shopping_activity/join_log_detail", { params: params });
    };
    ShopActivityService.prototype.getActStatusList = function (params) {
        return Axios.get("supplierclientapi/shopping_activity/status_option", { params: params });
    };
    ShopActivityService.prototype.getActTypeList = function (params) {
        return Axios.get("supplierclientapi/shopping_activity/activity_type_option", { params: params });
    };
    ShopActivityService.prototype.joinDetailPoint = function (params) {
        return Axios.get("supplierclientapi/shopping_activity/join_log_detail", { params: params });
    };
    ShopActivityService.prototype.pointType = function (params) {
        return Axios.get("supplierclientapi/shopping_activity/point_type_option", { params: params });
    };
    ShopActivityService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return ShopActivityService;
}());
export default ShopActivityService;
